<!--
 * @Author: your name
 * @Date: 2021-06-26 16:38:14
 * @LastEditTime: 2024-03-30 15:11:35
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\ToolsList\ToolIClock.vue
-->
<!--模拟时钟-->

<template>
  <div class="tool-iclock flex-c-c" :style="eleStyle">
    <canvas id="iclock" ref="iclock" :width="parseInt(winSize.wh*ratio)" :height="parseInt(winSize.wh*ratio)"></canvas>
  </div>
</template>

<script>
import { getZoneTime } from "@/assets/scripts/dateFormatting";
export default {
  name: "ToolIClock",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      winSize: {
        r: 0,
        wh: 0,
      },
      IntervalId: null,
      iclockCanvas: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      let canvas = this.$refs.iclock;
      this.iclockCanvas = canvas.getContext('2d');
      this.draw(this.iclockCanvas);
    });
  },
  methods: {
    draw(ctx) {
      // ctx.scale(this.ratio, this.ratio);
      let run = () => {
        this.drawDial(ctx); //绘制表盘
        this.media.ext_val_showText && this.drawWeekTime(ctx); // 绘制时间日期
        this.drawAllHands(ctx); //绘制时分秒针
        requestAnimationFrame(run);
      }
      requestAnimationFrame(run);
    },
    /*绘制时分秒针*/
    drawAllHands(ctx) {
      // 绘制表盘圆心
      ctx.beginPath();
      ctx.arc(this.winSize.r, this.winSize.r, 6, 0, 2 * Math.PI, false);
      ctx.fill();
      //获取当前时分秒时间
      let time = getZoneTime(this.media.ext_val_tzCount);
      let s = time.getSeconds();
      let m = time.getMinutes();
      let h = time.getHours();
      //计算出当前时分秒的弧度
      let pi = Math.PI;
      let secondAngle = pi / 180 * 6 * s;  //计算出来s针的弧度
      let minuteAngle = pi / 180 * 6 * m + secondAngle / 60;  //计算出来分针的弧度
      let hourAngle = pi / 180 * 30 * h + minuteAngle / 12;  //计算出来时针的弧度
      //绘制时分秒
      this.drawHand(hourAngle, this.winSize.r * 0.4, 6, this.media.ext_val_hourHandColor, ctx);  //绘制时针
      this.drawHand(minuteAngle, this.winSize.r * 0.6, 4, this.media.ext_val_minHandColor, ctx);  //绘制分针
      this.drawHand(secondAngle, this.winSize.r * 0.8, 2, this.media.ext_val_secHandColor, ctx);  //绘制秒针
    },
    /**
     * date.getFullYear(); //获取完整的年份(4位)
     * date.getMonth(); //获取当前月份(0-11,0代表1月)
     * date.getDate(); //获取当前日(1-31)
     * date.getDay(); //获取当前星期X(0-6,0代表星期天)
     */
    drawWeekTime(ctx) {
      // 获取时间
      let time = getZoneTime(this.media.ext_val_tzCount);
      // let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let week = ['日', '一', '二', '三', '四', '五', '六'][time.getDay()];
      // console.log(`${year}-${month}-${day}-${week}`);
      ctx.save();
      // let font = parseInt(this.media.ext_val_textSize);
      let font = parseInt(this.winSize.r / 10);
      // console.log(font);
      this.media.ext_val_textSize = this.winSize.wh / 14;
      ctx.fillStyle = this.media.ext_val_textColor;
      ctx.font = `${font}px sans-serif`
      ctx.textAlign = "center";
      let r = this.winSize.r;
      // ctx.fillText(`${year}年${month}月${day}日`, r, r + r / 2 - 16);
      ctx.fillText(`${month}/${day}`, r, r + r / 2 - (font * 1.2));
      ctx.fillText(`星期${week}`, r, r + r / 2);
      ctx.restore();
    },
    /*绘制时针、或分针、或秒针，
    * 参数1：要绘制的针的角度
    * 参数2：要绘制的针的长度
    * 参数3：要绘制的针的宽度
    * 参数4：要绘制的针的颜色
    * 参数4：ctx
    * */
    drawHand(angle, len, width, color, ctx) {
      ctx.save();
      ctx.translate(this.winSize.r, this.winSize.r); //把坐标轴的远点平移到原来的中心
      ctx.rotate(-Math.PI / 2 + angle);  //旋转坐标轴。 x轴就是针的角度
      ctx.beginPath();
      ctx.moveTo(- this.winSize.r * 0.1, 0);
      ctx.lineTo(len, 0);  // 沿着x轴绘制针
      ctx.lineWidth = width;
      ctx.strokeStyle = color;
      ctx.lineCap = "round";
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    },
    /*绘制表盘*/
    drawDial(ctx) {
      let pi = Math.PI;
      let wr = this.winSize.r; // 绘制窗口半径
      ctx.clearRect(0, 0, this.winSize.wh * this.ratio, this.winSize.wh * this.ratio);
      ctx.save();
      ctx.translate(wr, wr);
      ctx.beginPath();
      for (let i = 0; i < 60; i++) {//绘制刻度。
        ctx.save();
        ctx.rotate(-pi / 2 + i * pi / 30);  //旋转坐标轴。坐标轴x的正方形从 向上开始算起
        ctx.beginPath();
        ctx.moveTo(wr - 6, 0);
        ctx.lineTo((wr - 6 - (wr * 0.1)), 0);
        ctx.lineWidth = i % 5 ? 2 : 4;
        ctx.strokeStyle = i % 5 ? this.media.ext_val_minCircleColor : this.media.ext_val_hourCircleColor;
        ctx.stroke();
        ctx.closePath();
        ctx.restore();
        if (!(i % 5)) {
          ctx.save();
          let font = parseInt(this.winSize.r / 10);
          ctx.fillStyle = this.media.ext_val_textColor;
          ctx.font = `${font}px sans-serif`
          ctx.textAlign = "center";
          let r = (wr - 6 - (wr * 0.1)) - font; // 字体绘制半径
          let x = (Math.sin(Math.toRadians(i * 6)) * r);
          let y = - (Math.cos(Math.toRadians(i * 6)) * r) + font * 0.8 / 2;
          ctx.fillText(i === 0 ? 12 : i / 5, x, y);
          ctx.restore();
        }
      }
      ctx.restore();
    }
  },
  computed: {
    ratio() {
      return this.$store.state.program.ratio;
    },
    eleStyle() {
      return {
        'background': this.media.ext_val_backgroundColor,
      }
    }
  },
  watch: {
    media: {
      handler(nVal) {
        this.winSize.wh = nVal.w < nVal.h ? nVal.w : nVal.h;
        this.winSize.r = (this.winSize.wh / 2) * this.ratio;
      },
      deep: true,
      immediate: true
    },
    ratio: {
      handler() {
        this.winSize.r = (this.winSize.wh / 2) * this.ratio;
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-iclock {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>